enum DisputeStatus {
  SUPPORT_REQUESTED = "SUPPORT_REQUESTED",
  INFORMATION_REQUIRED = "INFORMATION_REQUIRED",
  UNDER_REVIEW = "UNDER_REVIEW",
  EXPIRED = "EXPIRED",
  WITHDRAWN = "WITHDRAWN",
  DISPUTE_CANCELED = "DISPUTE_CANCELED",
  CREATED = "CREATED",
  WON = "WON",
  LOST = "LOST",
  SUBMITTED = "SUBMITTED",
}

export default DisputeStatus;
